module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "idPan",
    staticStyle: {
      "height": "100%"
    }
  }, [_c('popwin', {
    staticStyle: {
      "width": "100%",
      "height": "100%"
    },
    attrs: {
      "ctrl": _vm.ctrlWin
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "flex": "0 0 auto",
      "width": "100%",
      "height": "50px"
    }
  }, [_c('div', {
    staticClass: "SiftPanel"
  }, [_c('div', {
    staticClass: "NButton DIVNoSelect",
    staticStyle: {
      "width": "70px",
      "margin-top": "-1px",
      "margin-left": "10px"
    },
    on: {
      "click": _vm.onTMAddClick
    }
  }, [_vm._v(_vm._s(_vm.getLangText('新增')))]), _vm._v(" "), _c('check', {
    key: _vm.KeyPrivate,
    staticStyle: {
      "height": "30px",
      "margin-right": "10px",
      "margin-left": "20px"
    },
    attrs: {
      "size": 18,
      "grpName": 'GrpRange',
      "val": 2,
      "capt": _vm.getLangText('私有'),
      "checked": _vm.chkPrivate
    }
  }), _vm._v(" "), _c('check', {
    key: _vm.KeyShare,
    staticStyle: {
      "height": "30px",
      "margin-right": "20px"
    },
    attrs: {
      "size": 18,
      "grpName": 'GrpRange',
      "val": 1,
      "capt": _vm.getLangText('公共'),
      "checked": _vm.chkShare
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "NButton DIVNoSelect",
    staticStyle: {
      "width": "32px",
      "height": "32px",
      "background": "url(../static/images/op_fin.png)",
      "margin-top": "-1px",
      "margin-left": "10px"
    },
    on: {
      "click": _vm.onTMListClick
    }
  })], 1)]), _vm._v(" "), _c('div', {
    ref: "idTablePan",
    staticStyle: {
      "margin-top": "6px",
      "border": "0px solid red",
      "display": "flex",
      "align-items": "center"
    }
  }, [_c('ctable', {
    attrs: {
      "ctrl": _vm.ctrlTable
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-12ac6f42","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/aiphoto/tmList.vue
// module id = 762
// module chunks = 1